import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";
import { PopupProvider, usePopup } from "./context/PopupContext";
import ContactPopup from "./components/ContactPopup";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import TrademarkRegistration from "./pages/TrademarkRegistration";
import CopyrightRegistration from "./pages/CopyrightRegistration";
import CompanyFormation from "./pages/CompanyFormation";
import TrademarkSearch from "./pages/TrademarkSearch";
import AmazonBrandRegistry from "./pages/AmazonBrandRegistry";
import ContactUs from "./pages/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import ApplicationMain from "./pages/ApplicationMain";

function AppContent() {
  const { isPopupOpen, closePopup } = usePopup();
  
  return (
    <div className="App">
      <ScrollToTop />
      <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/trademark-registration" element={<TrademarkRegistration />} />
          <Route path="/copyright-registration" element={<CopyrightRegistration />} />
          <Route path="/company-formation" element={<CompanyFormation />} />
          <Route path="/trademark-search" element={<TrademarkSearch />} />
          <Route path="/amazon-brand-registry" element={<AmazonBrandRegistry />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/application/main" element={<ApplicationMain />} />
      </Routes>
      <Footer />
      <Toaster />
      <ContactPopup isOpen={isPopupOpen} onClose={closePopup} />
    </div>
  );
}

function AppWrapper() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

function App() {
  return (
    <PopupProvider>
      <AppWrapper />
    </PopupProvider>
  );
}

export default App;
